import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { EmployerFundStatementsTable } from "../../../components/table/EmployerFundStatement/EmployerFundStatementsTable";
import { Pagination } from "../../../models";
import { EmployerFundStatement } from "../../../models/funding/employerFundStatement";
import { useCustomQuery, useData } from "../../../utils/useData";

export const Invoices = () => {
  const { employerFund } = useData();
  const { getClaim } = useKindeAuth();
  const employerId = getClaim("external_org_id")?.value;

  const [statementsPage, setStatementsPage] = useState(0);
  const [statementsPageSize, setStatementsPageSize] = useState(50);

  const statements = useCustomQuery<Pagination<EmployerFundStatement>>({
    endpoint: `/employers/${employerId}/employer-funds/${employerFund.data?.id}/statements`,
    queryKey: `statements-${statementsPage}-${statementsPageSize}`,
    pagination: {
      page: statementsPage,
      pageSize: statementsPageSize
    },
    options: {
      enabled: !!employerId && !!employerFund.data?.id
    }
  });

  useEffect(() => {
    statements.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statementsPage, statementsPageSize]);

  return (
    <Stack spacing={3} mt={2}>
      <EmployerFundStatementsTable
        statements={statements.data?.items ?? []}
        totalItems={statements.data?.totalItems ?? 0}
        page={statementsPage}
        pageSize={statementsPageSize}
        updatePage={setStatementsPage}
        updatePageSize={setStatementsPageSize}
        isLoading={statements.isLoading}
      />
    </Stack>
  );
};
